module.exports = __webpack_public_path__ + "assets/images/Sample3.8e8c17c7.jpg";